var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Instagram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/SocialInstagram",
    fill: "#212121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,2 C20.6568542,2 22,3.34314575 22,5 L22,19 C22,20.6568542 20.6568542,22 19,22 L5,22 C3.34314575,22 2,20.6568542 2,19 L2,5 C2,3.34314575 3.34314575,2 5,2 L19,2 Z M15.474493,5.52550697 L8.52550697,5.52550697 C6.86865272,5.52550697 5.52550697,6.86865272 5.52550697,8.52550697 L5.52550697,8.52550697 L5.52550697,15.474493 C5.52550697,17.1313473 6.86865272,18.474493 8.52550697,18.474493 L8.52550697,18.474493 L15.474493,18.474493 C17.1313473,18.474493 18.474493,17.1313473 18.474493,15.474493 L18.474493,15.474493 L18.474493,8.52550697 C18.474493,6.86865272 17.1313473,5.52550697 15.474493,5.52550697 L15.474493,5.52550697 Z M12,8.42784309 C13.9728478,8.42784309 15.5721569,10.0271522 15.5721569,12 C15.5721569,13.9728478 13.9728478,15.5721569 12,15.5721569 C10.0271522,15.5721569 8.42784309,13.9728478 8.42784309,12 C8.42784309,10.0271522 10.0271522,8.42784309 12,8.42784309 Z M12,9.72784309 C10.7451224,9.72784309 9.72784309,10.7451224 9.72784309,12 C9.72784309,13.2548776 10.7451224,14.2721569 12,14.2721569 C13.2548776,14.2721569 14.2721569,13.2548776 14.2721569,12 C14.2721569,10.7451224 13.2548776,9.72784309 12,9.72784309 Z M16.156981,7.41433525 C16.5893244,7.41433525 16.9398079,7.76481879 16.9398079,8.19716215 C16.9398079,8.62950551 16.5893244,8.97998905 16.156981,8.97998905 C15.7246376,8.97998905 15.3741541,8.62950551 15.3741541,8.19716215 C15.3741541,7.76481879 15.7246376,7.41433525 16.156981,7.41433525 Z",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialInstagram);
export default __webpack_public_path__ + "static/media/SocialInstagram.f8bb5980ad4ae09321569c22606dc686.svg";
export { ForwardRef as ReactComponent };